export async function UserRegistration(user) {
    try {
        //const users = user.phoneNumber;
        console.log("reg data : ", user);
      const response = await fetch('https://yesedacademy.com/database/user_registration.php', {
        method: 'POST',
        body: JSON.stringify({ user}),
        headers: {
          'Content-Type': 'application/json',
        },
      });
     
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const details = await response.json();
      return details;
    } catch (error) {
      throw new Error('Error fetching user data:', error);
    }
  }

 